import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Tile, Loading } from '@cv/eds-react';
import './EditVisualisationformcss.css';
import JsonView from 'react18-json-view';
import 'react18-json-view/src/style.css';
// import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
// import Loader from '../Loader';

import validator from '@rjsf/validator-ajv8';
import {
  RJSFSchema,
  UiSchema,
  WidgetProps,
  RegistryWidgetsType,
  ErrorListProps
} from '@rjsf/utils';
import Form from '@rjsf/core';

import { Button } from '@cv/eds-react/lib/components/button';
import { Input } from '@cv/eds-react/lib/components/input';
import { Select, SelectOption } from '@cv/eds-react/lib/components/select';
import useGetExportVisualisationSchema from '../../hooks/useGetExportVisualisationSchema';
import useCustomerData from '../../Context/CustomerDataContext';
import usePostExportData from '../../hooks/usePostExportData';
import useGetEditVisualisationById from '../../hooks/useGetEditVisualisationById';
import useGetVisualisationGraphById from '../../hooks/useGetVisualisationGraphById';
import { notification } from '@cv/eds-react/lib/components/notification';
import DynamicChart from '../Charts/DynamicChart';
import DynamicLayout from '../LayOuts/DynamicLayout';
import { CustomEDSInput, CustomEDSSelect } from '../CustomEDSComponents';
import { useHistory } from 'react-router-dom';

const CreateVisualizations = (props) => {
  const { dashboard_id } = useParams();
  const [isShowChart, setIsShowChart] = useState(false);
  const { customer } = useCustomerData();
  const [schemaData, setSchemaData] = useState({});
  const [formDataJson, setFormDataJson] = useState({});
  const [visualisationId, setVisualisationId] = useState('');
  const [graphData, setGraphData] = useState([{}]);
  const history = useHistory();

  // Visualisation Schema API
  const { data: respVisualisationSchemaData } = useGetExportVisualisationSchema(customer);

  useEffect(() => {
    setSchemaData(respVisualisationSchemaData?.data);
  }, [respVisualisationSchemaData]);

  // Create Visualisation API
  const postApiURL = '/config/' + customer + '/visualisation';
  const { 
    mutateAsync,
    data: visualisatuionResponse,
    isLoading,
    isError,
    error 
  } = usePostExportData(postApiURL);

  useEffect(() => {
    if (visualisatuionResponse?.id) {
      setVisualisationId(visualisatuionResponse?.id);
      setFormDataJson(visualisatuionResponse);
    }
  }, [visualisatuionResponse]);
  
  // Visualisation Chart API
  const { data: visualisationRespData } = useGetVisualisationGraphById(
    customer,
    visualisationId
    );

    useEffect(() => {
      if (visualisationRespData?.data) {
        const data = [visualisationRespData?.data];
        setGraphData(data);
        setIsShowChart(true);
      }
  }, [visualisationRespData?.data]);

  const widgets: RegistryWidgetsType = {
    TextWidget: CustomEDSInput,
    SelectWidget: CustomEDSSelect
  };
  const schemaObject: RJSFSchema = schemaData ? schemaData : {};

  const uiSchemaObject: UiSchema = {
    'ui:classNames': 'custom-form',
    id: {
      'ui:widget': 'hidden',
      'ui:classNames': 'custom-field'
    },
    name: {
      'ui:classNames': 'custom-field'
    },
    style: {
      'ui:classNames': 'custom-field'
    },
    index: {
      'ui:classNames': 'custom-field'
    },
    aggregation: {
      'ui:classNames': 'custom-field',
      'ui:options': {
        orderable: false
      },
      type: {
        'ui:classNames': 'custom-field'
      },
      field: {
        'ui:classNames': 'custom-field'
      },
      label: {
        'ui:classNames': 'custom-field'
      },
      'sub-aggregation': {
        'ui:classNames': 'custom-field custom-array-with-object-type1',
        'ui:options': {
          orderable: false
        },
        type: {
          'ui:classNames': 'custom-field'
        },
        field: {
          'ui:classNames': 'custom-field'
        },
        label: {
          'ui:classNames': 'custom-field'
        },
        'calendar-interval': {
          'ui:classNames': 'custom-field'
        },
        ranges: {
          'ui:classNames': 'custom-field',
          'ui:options': {
            orderable: false
          },
          'ui:classNames': 'custom-field',
          key: {
            'ui:classNames': 'custom-field'
          },
          from: {
            'ui:classNames': 'custom-field'
          },
          to: {
            'ui:classNames': 'custom-field'
          }
        }
      }
    },
    size: {
      'ui:classNames': 'custom-field'
    }
  };

  function transformErrors(errors, uiSchema) {
    return errors.map((error) => {
      return error;
    });
  }
  function ErrorListTemplate(props: ErrorListProps) {
    const { errors } = props;
    return <></>;
  }

  const handleSubmitObject = async ({ formData }, e) => {
    try {
      const response = await mutateAsync(formData);
      if (response.error) {
        setTimeout(() => {
          notification.notice("Some error occured. please try again after sometime.");
        }, 1000);
      } else {
        notification.notice('Visualization added successfully!!!');
        history.push('/visualizations');
      }
    } catch (error) {
      setTimeout(() => {
        notification.notice(error?.response?.data?.message);
      }, 1000);
    }
  };
  const handleErrorObject = (e) => {
    e.forEach((error) => {
      notification.notice(error?.stack);
    });
  };
  const cards = graphData.length != 0  ? graphData : [];

  const cardsWithComponents = cards.map((card) => {
    return {
      ...card,
      component: (props) => <DynamicChart {...props} {...card.chartProps} />
    };
  });

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        {/* <Loading size="medium" /> */}
      </div>
    );
  } else if (isError) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <p>
          {error?.message ? error?.message : 'Something went wrong please try again.'}
        </p>
      </div>
    );
  } else {
    return (
      <div className="position-relative">
      <div className="row">
        <div className="column sm-12">
          <Tile>
            <Row>
              <Col span={6}>
                <Card>
                  <Form
                    schema={schemaObject}
                    uiSchema={uiSchemaObject}
                    onSubmit={handleSubmitObject}
                    onError={handleErrorObject}
                    widgets={widgets}
                    formData={formDataJson}
                    validator={validator}
                    transformErrors={transformErrors}
                    liveValidate
                    templates={{ ErrorListTemplate }}
                  >
                    <>
                      <Button type="submit" children="Save" />
                    </>
                  </Form>
                </Card>
              </Col>
              <Col span={6}>
                <Card>
                  {isShowChart ? (
                    <DynamicLayout cards={cardsWithComponents} />
                  ) : (
                    <JsonView src={formDataJson} />
                  )}
                </Card>
              </Col>
            </Row>
          </Tile>
        </div>
      </div>
    </div>
    );
  }
};

export default React.memo(CreateVisualizations);
